import { FileDropzone } from "../../shared/components";

interface PayComponentImportDropzoneProps {
  /** When true, the dropzone is disabled (e.g. company code not yet validated). */
  isDisabled?: boolean;
  isProcessing?: boolean;
  onFileSelected?: (file: File) => void;
}

const CSV_SUB_INSTRUCTION =
  "Accepted format: CSV (.csv). The file must contain an Employee Code and Component Name column (or pick the component column below).";

export function PayComponentImportDropzone({
  isDisabled = false,
  isProcessing = false,
  onFileSelected,
}: PayComponentImportDropzoneProps) {
  const handleFileChange = (files: File | File[] | null) => {
    if (files && !Array.isArray(files)) {
      onFileSelected?.(files);
    }
  };

  return (
    <FileDropzone
      value={null}
      onChange={handleFileChange}
      instruction="Drop your CSV file here, or click to browse"
      subInstruction={CSV_SUB_INSTRUCTION}
      accept=".csv"
      multiple={false}
      isDisabled={isDisabled || isProcessing}
      buttonText="Select CSV file"
      disabledButtonText={
        isDisabled && !isProcessing
          ? "Enter a company code first"
          : "Processing..."
      }
      fileFilter={(file) => file.name.toLowerCase().endsWith(".csv")}
    />
  );
}
